import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-charcoal-light dark:text-bone/60 text-sm tracking-wide">
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-terracotta animate-pulse mr-2" />
        Settling in…
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/community" replace />;
  }
  return children;
}
